import React from 'react';
import Button from '@cvent/carina/components/Button';
import { Tooltip } from '@cvent/carina/components/Tooltip';
import { useTranslate } from 'nucleus-text';
import { AllPlacements as Placements } from '@cvent/carina/components/Popper/Placements';
import useBreakpoints from '@hooks/useBreakpoints';

type JoinSessionTooltipButtonProps = {
  sessionName: string;
  size?: 's' | 'm' | 'l';
  hasHigherPermission?: boolean;
};

function JoinSessionTooltipButton({
  sessionName,
  size = 'm',
  hasHigherPermission
}: JoinSessionTooltipButtonProps): JSX.Element {
  const { translate } = useTranslate();
  const { isMobile } = useBreakpoints();

  return (
    <Tooltip
      placement={isMobile ? Placements.topEnd : Placements.right}
      text={translate('SessionCard-Join-Button-Tooltip')}
      portal
      trigger={
        <Button
          disabled="style-only" // Had to set this to a string to make tooltip disappear on mouseLeft
          testID="enter-session-button"
          text={
            hasHigherPermission
              ? translate('SessionCard-Join-Button-HighPermission')
              : translate('SessionCard-Join-Button')
          }
          size={size}
          appearance="filled"
          aria-label={translate('SessionCard-Disabled-Join-Button-Accessibility-Label', { sessionName })}
        />
      }
    />
  );
}

export default JoinSessionTooltipButton;
